import isString from 'lodash/isString';
import React, { useEffect, useState } from 'react';
import { getMediaUrl } from 'services/conversations.service';

export default (link) => {
  const [state, setState] = useState({ url: null, loading: false });
  useEffect(() => {
    if (!link || link === '0' || !isString(link)) {
      setState({ url: null, loading: false });
    } else if (link.startsWith('http')) {
      setState({ url: link, loading: false });
    } else {
      setState({ loading: true, url: null });
      getMediaUrl(link).then((url) => {
        setState({ loading: false, url });
      });
    }
  }, [link]);
  return state;
};
